var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8011 29.8C27.1619 29.8 23.4011 26.0392 23.4011 21.4C23.4011 16.7608 27.1619 13 31.8011 13C36.4404 13 40.2012 16.7608 40.2012 21.4C40.2012 26.0392 36.4404 29.8 31.8011 29.8Z",
    fill: "#333D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9995 45.5501C14.9995 50.7693 14.9995 55.0001 31.7996 55.0001C48.5996 55.0001 48.5996 50.7693 48.5996 45.5501C48.5996 40.331 41.078 36.1001 31.7996 36.1001C22.5211 36.1001 14.9995 40.331 14.9995 45.5501Z",
    fill: "#333D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 52C62.5 57.5228 58.0228 62 52.5 62C46.9771 62 42.5 57.5228 42.5 52C42.5 46.4771 46.9771 42 52.5 42C58.0228 42 62.5 46.4771 62.5 52Z",
    fill: "#00A86B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5952 48.3977L50.7919 48.045C51.5519 46.6817 51.9319 46 52.5 46C53.0681 46 53.4481 46.6817 54.2081 48.045L54.4048 48.3978C54.6206 48.7852 54.7286 48.9789 54.897 49.1067C55.0654 49.2345 55.2751 49.2819 55.6945 49.3768L56.0762 49.4632C57.5521 49.7971 58.29 49.9641 58.4655 50.5287C58.6411 51.0932 58.1381 51.6814 57.132 52.858L56.8716 53.1623C56.5857 53.4966 56.4428 53.6638 56.3785 53.8707C56.3142 54.0774 56.3358 54.3005 56.379 54.7465L56.4183 55.1526C56.5705 56.7223 56.6465 57.5073 56.1869 57.8561C55.7273 58.2051 55.0364 57.8869 53.6546 57.2507L53.2972 57.0861C52.9044 56.9053 52.7081 56.8149 52.5 56.8149C52.2919 56.8149 52.0956 56.9053 51.7028 57.0861L51.3454 57.2507C49.9636 57.8869 49.2727 58.2051 48.8131 57.8561C48.3535 57.5073 48.4295 56.7223 48.5816 55.1526L48.621 54.7465C48.6642 54.3005 48.6858 54.0774 48.6215 53.8707C48.5572 53.6638 48.4143 53.4966 48.1284 53.1623L47.8681 52.858C46.8619 51.6814 46.3589 51.0932 46.5345 50.5287C46.71 49.9641 47.4479 49.7971 48.9237 49.4632L49.3055 49.3768C49.7249 49.2819 49.9346 49.2345 50.103 49.1067C50.2714 48.9789 50.3794 48.7852 50.5952 48.3977Z",
    fill: "#00FFA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile-icon.b9bb5afc383f96990337d1c45e9781f1.svg";
export { ForwardRef as ReactComponent };